module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1130.c183e4a3.png";